import { Tile, TileType } from './types';

// Editor-friendly format: positions stored as integers × 2 to avoid float JSON.
// rowX2=1 → row=0.5, rowX2=2 → row=1.0, etc.
export interface TilePlacement {
  rowX2: number;
  colX2: number;
  layer: number;
}

export interface LevelDef {
  id: string;
  name: string;
  seed: number;            // RNG seed for tile-type assignment
  tileTypes: number;       // number of distinct types; total tiles = tileTypes * 3
  placements: TilePlacement[];
  maxRowX2: number;
  maxColX2: number;
}

export { LEVELS } from './levels/index';

export function parkMiller(seed: number): () => number {
  let s = seed | 0 || 1;
  return () => {
    s = ((Math.imul(s, 16807) % 2147483647) + 2147483647) % 2147483647 || 1;
    return (s - 1) / 2147483646;
  };
}

export function generateLevel(def: LevelDef): Tile[] {
  const rng = parkMiller(def.seed);

  const pool: TileType[] = [];
  for (let t = 0; t < def.tileTypes; t++) pool.push(t, t, t);

  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }

  return def.placements.map((p, i) => ({
    id: i,
    type: pool[i],
    row: p.rowX2 / 2,
    col: p.colX2 / 2,
    layer: p.layer,
  }));
}
